import "vite/modulepreload-polyfill";

import { initSentry } from "../lib/sentry";

// Initialize Sentry as early as possible
initSentry();

import "../lib/cranky";
import "../lib/embla-carousel";
import "../lib/alpine";

import "../lib/logging";

// Import legacy @theme modules that are now in frontend/lib
import "../lib/critical";
import "../lib/component";
import "../lib/dialog";
import "../lib/events";
import "../lib/utilities";
import "../lib/video-background";
import "../lib/media";
import "../lib/placeholder-image";
